/** ชนิดข้อมูลของหน้าจอจัดการโรงงานและคลัง/ที่เก็บ (D-176) — รหัสธุรกิจล้วน ไม่มี UUID */

export interface CompanyCode {
  readonly company_code: string;
  readonly name: string;
}

export interface Plant {
  readonly plant_code: string;
  readonly name: string;
  readonly company_code: string;
  readonly storage_location_count: number;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface StorageLocation {
  readonly plant_code: string;
  readonly storage_location_code: string;
  readonly name: string;
  readonly location_type: string;
  readonly created_at: string;
  readonly updated_at: string;
}

/** ชนิดที่สร้างจากหน้านี้ได้ — SUBCONTRACTOR ผูกผู้ขายจึงสร้างที่นี่ไม่ได้ (D-176 ข้อ 3) */
export const CREATABLE_LOCATION_TYPES = ['WAREHOUSE', 'STAGING', 'SUPERMARKET'] as const;

export const LOCATION_TYPE_LABELS: Readonly<Record<string, string>> = {
  WAREHOUSE: 'คลัง',
  STAGING: 'จุดพักก่อนผลิต',
  SUPERMARKET: 'ซูเปอร์มาร์เก็ต',
  SUBCONTRACTOR: 'ผู้รับจ้างช่วง',
};

export const ORG_RULES = {
  PLANT_CODE_TAKEN: 'PLANT_CODE_TAKEN',
  PLANT_NOT_FOUND: 'PLANT_NOT_FOUND',
  COMPANY_CODE_NOT_FOUND: 'COMPANY_CODE_NOT_FOUND',
  STORAGE_LOCATION_CODE_TAKEN: 'STORAGE_LOCATION_CODE_TAKEN',
  STORAGE_LOCATION_NOT_FOUND: 'STORAGE_LOCATION_NOT_FOUND',
  SUBCONTRACTOR_LOCATION_NOT_CREATABLE: 'SUBCONTRACTOR_LOCATION_NOT_CREATABLE',
  LOCATION_TYPE_INVALID: 'LOCATION_TYPE_INVALID',
} as const;
